<template>
    <section class="c-benefit-why-quarkino">
        <div
            v-if="hasTitleAndSubtitle"
            class="title-and-subtitle"
        >
            <h2
                v-if="content.title2"
                class="benefit-title"
                v-text="content.title2"
            />
            <p
                v-if="content.subtitle"
                class="benefit-subtitle"
                v-text="content.subtitle"
            />
        </div>
        <div
            class="c-benefit-why-quarkino__wrapper"
        >
            <div class="c-benefit-why-quarkino__texts">
                <h1
                    v-if="!hasTitleAndSubtitle"
                    class="c-benefit-why-quarkino__title"
                >
                    {{ content.title2 }}
                </h1>
                <div class="c-benefit-why-quarkino__items">
                    <div
                        v-for="item in content.albums"
                        :key="item.id"
                        class="c-benefit-why-quarkino__item"
                    >
                        <div class="c-benefit-why-quarkino__item--box">
                            <img
                                :src="item.link"
                                alt="item.title "
                            >
                            <h3>
                                {{ item.title }}
                            </h3>
                        </div>
                        <p>
                            {{ item.description }}
                        </p>
                    </div>
                </div>
                <div
                    v-if="content.custom"
                    class="c-benefit-why-quarkino__action"
                >
                    <y-button
                        color="primary"
                        :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                        :to="content.custom['button-link']"
                        :href="content.custom['button-link']"
                    >
                        {{ content.custom['button-title'] }}
                    </y-button>
                </div>
            </div>
            <div class="c-benefit-why-quarkino__image">
                <img
                    :src="content.image.link"
                    :alt="content.title2"
                >
            </div>
        </div>
    </section>
</template>

<script >
    import { isLink } from '@/helpers/helpers';

    export default {
        name: 'WhyQuarkinoBenefit',

        props: {
            content            : Object,
            hasTitleAndSubtitle: Boolean,
        },

        methods: {
            isLink,
        },
    };

</script>

<style lang="scss" src="./benefit.scss"/>
